/* Theme presentation policy, not a Shopify payment-provider or /checkout lock. */
(() => {
  if (window.StudioDanzaPaymentPolicy) return;
  const html = document.documentElement;
  const nativeSelector = '[data-testid="cart-drawer-trigger"], .action__cart, a[href*="/cart"], a[href*="/checkout"], .add-to-cart-button, button[name="add"], [name="checkout"], .quick-add, sticky-add-to-cart, .accelerated-checkout-block, .studio-danza-accelerated-checkout, .shopify-payment-button, .additional-checkout-buttons, shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .quantity-selector-wrapper';
  const nativeFormSelector = 'form[action*="/cart/add"], form[action*="/cart"], form[data-type="add-to-cart-form"]';
  const cashSelector = '[id^="cash-payment-button-"], .cash-submit, [id^="cash-payment-modal-"]';
  const speiSelector = '[id^="bank-transfer-button-"], [id^="bank-transfer-form-"], [id^="bank-transfer-modal-"]';
  let settings = null;
  let state = 'loading';
  let generation = 0;
  const allowed = (method) => state === 'ready' && Boolean(settings) && (method === 'native' ? settings.cardPaymentEnabled && settings.shopifyCheckoutEnabled : method === 'cash' ? settings.cashPaymentEnabled : method === 'spei' ? settings.speiPaymentEnabled : false);
  function render() {
    html.setAttribute('data-sd-payment-state', state);
    for (const method of ['native', 'cash', 'spei']) html.setAttribute(`data-sd-${method}`, String(allowed(method)));
    const any = allowed('native') || allowed('cash') || allowed('spei');
    html.setAttribute('data-sd-payment-any', String(any));
    const text = state === 'loading' ? 'Consultando métodos de pago…' : state === 'error' ? 'No pudimos consultar los métodos de pago. Recarga la página para intentar de nuevo.' : !any ? 'Los pagos no están disponibles por el momento. Contacta a la academia.' : '';
    document.querySelectorAll('[data-sd-payment-status]').forEach(node => {
      // Non-course products cannot use the direct course-reservation methods.
      const nativeOnly = node.hasAttribute('data-sd-native-only');
      const message = nativeOnly && state === 'ready' && !allowed('native') ? 'El carrito y el checkout de Shopify no están disponibles. Contacta a la academia.' : text;
      if (node.textContent !== message) node.textContent = message;
      node.hidden = !message;
    });
    for (const [method, selector] of [['cash', cashSelector], ['spei', speiSelector]]) {
      if (!allowed(method)) document.querySelectorAll(selector).forEach(node => { if (node.open && typeof node.close === 'function') node.close(); });
    }
  }
  async function refresh() {
    const current = ++generation;
    settings = null; state = 'loading'; render();
    const controller = new AbortController();
    const timer = window.setTimeout(() => controller.abort(), 10000);
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root.replace(/\/?$/, '/')}apps/studio-danza/payment-settings`, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }, signal: controller.signal });
      if (!response.ok) throw new Error('policy unavailable');
      const payload = await response.json();
      const next = payload?.paymentSettings;
      if (!next || !['cashPaymentEnabled','speiPaymentEnabled','cardPaymentEnabled','shopifyCheckoutEnabled'].every(key => typeof next[key] === 'boolean')) throw new Error('invalid policy');
      if (current !== generation) return;
      settings = next; state = 'ready';
    } catch {
      if (current !== generation) return;
      settings = null; state = 'error';
    } finally {
      window.clearTimeout(timer);
      if (current === generation) render();
    }
  }
  function blockUnavailable(event) {
    const target = event.target;
    if (!target?.closest) return;
    const method = target.closest(cashSelector) ? 'cash' : target.closest(speiSelector) ? 'spei' : target.closest(nativeSelector) || (event.type === 'submit' && target.closest(nativeFormSelector)) ? 'native' : null;
    if (method && !allowed(method)) { event.preventDefault(); event.stopImmediatePropagation(); }
  }
  document.addEventListener('click', blockUnavailable, true);
  document.addEventListener('submit', blockUnavailable, true);
  document.addEventListener('DOMContentLoaded', () => {
    render();
    new MutationObserver(render).observe(document.body, {childList:true, subtree:true});
  });
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') void refresh(); });
  window.addEventListener('pageshow', event => { if (event.persisted) void refresh(); });
  window.StudioDanzaPaymentPolicy = { allowed, refresh, ready: null };
  window.StudioDanzaPaymentPolicy.ready = refresh();
})();
